import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { LeftPaginateIcon } from "../Assets/svg/LefiPaginateIcon";
import { LeftIcon } from "../Assets/svg/LeftIcon";
import { RightPaginationIcon } from "../Assets/svg/RightPaginationIcon";
import { RightIcon } from "../Assets/svg/RightIcon";
// import {
//   getAdvisorClientDocuments,
//   getAdvisorClientProperties,
// } from "../redux/slice/advClientSlice";

export const Pagination = ({ setPage, page, flag }) => {
  const advPagination = useSelector((state) => state.advisorManagement);
  const clientPagination = useSelector((state) => state.clientManagement);
  const documentPagination = useSelector((state) => state.document);
  const auditPagination = useSelector((state) => state.auditLogs);
  const userPagination = useSelector((state) => state.userManagement);
  const advClient = useSelector((state) => state.advClient);
  const { clientMainPagination } = useSelector(
    (state) => state.advDocument
  );

  const clientAdvisorListPagination = useSelector(
    (state) => state.clientFinancialAdvisor || {}
  );
  const advDocument = useSelector((state) => state.advDocument);
  const advisorClientDocuments = useSelector((state) => state.advClient);
  const advisorClientProperties = useSelector((state) => state.advClient);
  const { investorsPagination } = useSelector(
    (state) => state.advisorDocuments
  );
  const {
    accountPagination
  } = useSelector((state) => state.fetchClientsAccountsResponse);
  const { propertyPagination } = useSelector(
    (state) => state.advisorDocuments
  );
  const { DocumentPropertiespagination } = useSelector(
    (state) => state.advDocument
  );
  const { clientPerformacePagination } = useSelector((state) => state.clientDocument);
  const { pagination: adminDocPage, Clientpagination, clientSecurityPagination } =
    useSelector((state) => state.document);
  const changeRequestsPagination = useSelector((state) => state.changeRequests?.pagination);
  const relatedPartiesPagination = useSelector((state) => state.relatedParty?.pagination);


  const defaultPagination = {
    currentPage: 1,
    itemsPerPage: 10,
    totalPages: 1,
    totalItems: 0,
  };

  const pagination =
    flag === "advisor"
      ? advPagination?.pagination
      : flag === "client"
        ? clientPagination?.pagination
        : flag === "document"
          ? documentPagination?.pagination
          : flag === "audit"
            ? auditPagination.pagination
            : flag === "user"
              ? userPagination.pagination
              : flag === "client-advisor"
                ? clientPagination?.pagination
                : flag === "clientfinancial-advisor"
                  ? clientPagination?.advisorsPagination || defaultPagination
                  : flag === "clientAdvisorList"
                    ? clientAdvisorListPagination.pagination
                    : flag === "adv-client"
                      ? advClient.pagination
                      : flag === "advisor-detail"
                        ? investorsPagination || []
                        : flag === "property"
                          ? propertyPagination || defaultPagination
                          : flag === "docClient"
                            ? documentPagination?.pagination
                            : flag === "docProperty"
                              ? documentPagination?.pagination
                              : flag === "docClientsadvisor"
                                ? advDocument?.pagination || defaultPagination
                                : flag === "docClientAdvisor" ?
                                  advDocument.advInvestorPagination || []
                                  : flag === "advisor-client-documents"
                                    ? advisorClientDocuments.docPagination
                                    : flag === "docPropertyForClient"
                                      ? DocumentPropertiespagination
                                      : flag === "advisor-client-properties"
                                        ? advisorClientProperties.propertiesPagination
                                        : flag === "advisorproperty"
                                          ? advDocument.pagination
                                          : flag === "client-account"
                                            ? accountPagination
                                            : flag === "admin-doc-tab"
                                              ? adminDocPage
                                              : flag === "client-doc-tab"
                                                ? Clientpagination
                                                : flag === "client-security-doc"
                                                  ? clientSecurityPagination
                                                  : flag === "client-main-doc"
                                                    ? clientMainPagination
                                                    : flag === "adminClient-doc"
                                                      ? clientPerformacePagination
                                                      : flag === "change-requests"
                                                        ? changeRequestsPagination
                                                        : flag === "related-parties"
                                                          ? relatedPartiesPagination
                                                          : defaultPagination;
  const [goToPage, setGoToPage] = useState("");
  const [limitValue, setLimitValue] = useState(pagination.itemsPerPage);
  useEffect(() => {
    setLimitValue(pagination.itemsPerPage);
  }, [pagination.itemsPerPage]);

  useEffect(() => {
    setGoToPage("");
  }, []);

  const handleLimitChange = () => {
    if (limitValue <= pagination.totalItems && page) {
      //totalItems

      setPage({ ...page, currentPage: 1, itemsPerPage: limitValue });
    } else {

      setLimitValue(pagination.totalItems);
    }
  };
  const handleGoToFirst = () => {
    if (page) {
      setPage({ ...page, currentPage: 1 });
    }
  };
  const handleGoToLast = () => {
    if (page) {
      setPage({ ...page, currentPage: pagination.totalPages });
    }
  };

  const handlePrevious = () => {
    if (pagination.currentPage !== 1) {
      setPage({ ...page, currentPage: pagination.currentPage - 1 });
    }
  };
  const handleNext = () => {
    if (pagination.currentPage < pagination.totalPages && page) {
      setPage({ ...page, currentPage: pagination.currentPage + 1 });
    }
  };

  const handleGoToPage = (pageValue) => {
    if (pageValue <= pagination.totalPages && page) {
      setPage({ ...page, currentPage: pageValue });
    } else {
      setGoToPage("");
    }
  };
  return (
    <div className="pagination">
      <div className="pagination__result">
        {`${pagination.currentPage * pagination.itemsPerPage -
          pagination.itemsPerPage +
          1
          }-${pagination.currentPage !== pagination.totalPages
            ? pagination.itemsPerPage * pagination.currentPage
            : pagination.totalItems
          } of ${pagination.totalItems} items`}
        <div className="pagination__actions">
          <h6>Items per page:</h6>
          <input
            onChange={(e) => setLimitValue(e.target.value)}
            type="text"
            className="formField__input sm"
            value={limitValue}
          />
          <button onClick={handleLimitChange} className="btn btn__primary">
            Go
          </button>
        </div>
      </div>
      <nav
        aria-label="pagination navigation"
        className="MuiPagination-root MuiPagination-outlined css-1oj2twp-MuiPagination-root"
      >
        <ul className="MuiPagination-ul css-wjh20t-MuiPagination-ul">
          <li>
            <button
              className="MuiButtonBase-root Mui-disabled MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded Mui-disabled MuiPaginationItem-firstLast css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
              tabIndex="-1"
              type="button"
              disabled=""
              aria-label="Go to first page"
              onClick={handleGoToFirst}
            >
              <LeftPaginateIcon />
            </button>
          </li>
          <li>
            <button
              className="MuiButtonBase-root Mui-disabled MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded Mui-disabled MuiPaginationItem-previousNext css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
              tabIndex="-1"
              type="button"
              disabled=""
              aria-label="Go to previous page"
              onClick={handlePrevious}
            >
              <LeftIcon />
            </button>
          </li>
          <li>
            <button
              className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded Mui-selected MuiPaginationItem-page css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
              tabIndex="0"
              type="button"
              aria-current="true"
              aria-label="page 1"
              onClick={() => {
                handleGoToPage(pagination.currentPage);
              }}
            >
              {`${pagination.currentPage}`}
              <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
            </button>
          </li>
          {pagination.currentPage !== pagination.totalPages && (
            <li>
              <button
                className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded MuiPaginationItem-page css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
                tabIndex="0"
                type="button"
                aria-label="Go to page 2"
                onClick={() => {
                  handleGoToPage(pagination.currentPage + 1);
                }}
              >
                {`${pagination.currentPage + 1}`}
                <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
              </button>
            </li>
          )}
          <li>
            <button
              className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded MuiPaginationItem-previousNext css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
              tabIndex="0"
              type="button"
              aria-label="Go to next page"
              onClick={handleNext}
            >
              <RightPaginationIcon />
              <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
            </button>
          </li>
          <li>
            <button
              className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded MuiPaginationItem-firstLast css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
              tabIndex="0"
              type="button"
              aria-label="Go to last page"
              onClick={handleGoToLast}
            >
              <RightIcon />
              <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
            </button>
          </li>
        </ul>
      </nav>
      <div className="pagination__actions">
        <h6>Go to page</h6>
        <input
          type="text"
          className="formField__input sm"
          onChange={(e) => setGoToPage(e.target.value)}
          value={goToPage}
        />
        <button
          onClick={() => handleGoToPage(goToPage)}
          className="btn btn__primary"
        >
          Go
        </button>
      </div>
    </div>
  );
};

export default Pagination;
